import { render } from "./FloatingLinkComponent.vue?vue&type=template&id=2c0ff504&scoped=true&ts=true"
import script from "./FloatingLinkComponent.vue?vue&type=script&lang=ts"
export * from "./FloatingLinkComponent.vue?vue&type=script&lang=ts"

import "./FloatingLinkComponent.vue?vue&type=style&index=0&id=2c0ff504&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0ff504"]])

export default __exports__